import React from 'react';
import {
  Accordion,
} from 'anf-core-react';

export default function BuyGridAccordion({
  headerText,
  id,
  children,
  expanded,
  onClick,
}) {
  return (
    <div className={id}>
      <Accordion
        variant="bordered"
        headingLevel={3}
        id={id}
        title={headerText}
        theme="secondary-light"
        onClick={onClick}
        isExpanded={expanded}
      >
        <div className="buy-grid-accordion-container">
          { children }
        </div>
      </Accordion>
    </div>
  );
}
